// extracted by mini-css-extract-plugin
module.exports = {"underLink":"TruncateLog_underLink__ZETxN"};